<div class="ha-how-you-think-section section-wrapper">
	<div id="lifestyle-how-you-think">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-think.heading'">How You Think</span>
		</div>

		<div class="form-group" [formGroup]="howYouThinkForm">
			<div class="form-field">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.how-you-think-section1'">
					Over the last two weeks, how often have you been bothered by the following problems?
				</div>

				<div class="question-wrapper">
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.lastTwoWeeksFeelingNervous'
						">
						Feeling nervous, anxious, or an edge:
					</div>
					<mat-radio-group
						[(ngModel)]="howYouThinkData.lastTwoWeeksFeelingNervous"
						formControlName="lastTwoWeeksFeelingNervous"
						[disabled]="readOnly">
						<mat-radio-button appAutofocus [value]="condition.id" *ngFor="let condition of botheredByProblemsLookup">
							<span>{{ condition.name }}</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="question-wrapper">
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.lastTwoWeeksUnableStopWorrying'
						">
						Not being able to stop or control worrying:
					</div>
					<mat-radio-group
						[(ngModel)]="howYouThinkData.lastTwoWeeksUnableStopWorrying"
						formControlName="lastTwoWeeksUnableStopWorrying"
						[disabled]="readOnly">
						<mat-radio-button [value]="condition.id" *ngFor="let condition of botheredByProblemsLookup">
							<span>{{ condition.name }}</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="question-wrapper">
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.lastTwoWeeksLittleInterest'
						">
						Little interest or pleasure in doing things:
					</div>
					<mat-radio-group
						[(ngModel)]="howYouThinkData.lastTwoWeeksLittleInterest"
						formControlName="lastTwoWeeksLittleInterest"
						[disabled]="readOnly">
						<mat-radio-button [value]="condition.id" *ngFor="let condition of botheredByProblemsLookup">
							<span>{{ condition.name }}</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="question-wrapper">
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.lastTwoWeeksFeelingDepressed'
						">
						Feeling down, depressed or hopeless:
					</div>
					<mat-radio-group
						[(ngModel)]="howYouThinkData.lastTwoWeeksFeelingDepressed"
						formControlName="lastTwoWeeksFeelingDepressed"
						[disabled]="readOnly">
						<mat-radio-button [value]="condition.id" *ngFor="let condition of botheredByProblemsLookup">
							<span>{{ condition.name }}</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="slider-group">
					<div
						class="radio-btn-label"
						[translate]="'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.how-you-think-section2'">
						For each of the following statements and questions, select the point on the scale that you feel is most
						appropriate in describing you.
					</div>

					<div>
						<div
							class="question-label radio-btn-label"
							[translate]="
								'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.inGeneralConsiderMyself'
							">
							In general, I consider myself:
						</div>
						<div class="slider">
							<div class="slider-labels">
								<span class="label-left">{{ considerMyselfRatingLookup[0]?.name }}</span>
								<span class="label-right">{{
									considerMyselfRatingLookup[considerMyselfRatingLookup.length - 1]?.name
								}}</span>
							</div>
							<mat-slider
								[disabled]="readOnly"
								[max]="considerMyselfSlider.max"
								[min]="considerMyselfSlider.min"
								[step]="considerMyselfSlider.step"
								[showTickMarks]="true">
								<input matSliderThumb formControlName="inGeneralConsiderMyself" />
							</mat-slider>
						</div>
					</div>

					<div>
						<div
							class="question-label radio-btn-label"
							[translate]="
								'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.comparedToMostConsiderMyself'
							">
							Compared to most of my peers, I consider myself:
						</div>
						<div class="slider">
							<div class="slider-labels">
								<span class="label-left">{{ considerMyselfRatingLookup[0]?.name }}</span>
								<span class="label-right">{{
									considerMyselfRatingLookup[considerMyselfRatingLookup.length - 1]?.name
								}}</span>
							</div>
							<mat-slider
								[disabled]="readOnly"
								[max]="considerMyselfSlider.max"
								[min]="considerMyselfSlider.min"
								[step]="considerMyselfSlider.step"
								[showTickMarks]="true">
								<input matSliderThumb formControlName="comparedToMostConsiderMyself" />
							</mat-slider>
						</div>
					</div>
				</div>
				<div class="slider-group">
					<div class="radio-btn-label">
						Some people are generally very happy. They enjoy life regardless of what is going on, getting the most out
						of everything.
						<div>
							<div
								class="question-label radio-btn-label"
								[translate]="
									'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.characterizationDescribeGenerallyVeryHappy'
								">
								To what extent does this characterization describe you?
							</div>
							<div class="slider">
								<div class="slider-labels">
									<span class="label-left">{{ characterizationLookup[0]?.name }}</span>
									<span class="label-right">{{ characterizationLookup[characterizationLookup.length - 1]?.name }}</span>
								</div>
								<mat-slider
									[disabled]="readOnly"
									[max]="characterizationSlider.max"
									[min]="characterizationSlider.min"
									[step]="characterizationSlider.step"
									[showTickMarks]="true">
									<input matSliderThumb formControlName="characterizationDescribeGenerallyVeryHappy" />
								</mat-slider>
							</div>
						</div>
					</div>
				</div>
				<div class="slider-group">
					<div class="radio-btn-label">
						Some people are generally not very happy. Although they are not depressed, they never seem as happy as they might be.
						<div>
							<div
								class="question-label radio-btn-label"
								[translate]="'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.characterizationDescribeGenerallyNotVeryHappy'">
								To what extent does this characterization describe you?
							</div>
							<div class="slider">
								<div class="slider-labels">
									<span class="label-left">{{ characterizationLookup[0]?.name }}</span>
									<span class="label-right">{{ characterizationLookup[characterizationLookup.length - 1]?.name }}</span>
								</div>
								<mat-slider
									[disabled]="readOnly"
									[max]="characterizationSlider.max"
									[min]="characterizationSlider.min"
									[step]="characterizationSlider.step"
									[showTickMarks]="true">
									<input matSliderThumb formControlName="characterizationDescribeGenerallyNotVeryHappy" />
								</mat-slider>
							</div>
						</div>
					</div>
				</div>
				<div class="question-wrapper">
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.tendToBounceBackAfterHardTimes'
						">
						I tend to bounce back quickly after hard times.
					</div>
					<mat-radio-group
						[(ngModel)]="howYouThinkData.tendToBounceBackAfterHardTimes"
						formControlName="tendToBounceBackAfterHardTimes"
						[disabled]="readOnly">
						<mat-radio-button [value]="condition.id" *ngFor="let condition of thinkReactionOptions">
							<span>{{ condition.name }}</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="question-wrapper">
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.hardTimeMakingThroughStress'
						">
						I have a hard time making it through stressful events.
					</div>
					<mat-radio-group
						[(ngModel)]="howYouThinkData.hardTimeMakingThroughStress"
						formControlName="hardTimeMakingThroughStress"
						[disabled]="readOnly">
						<mat-radio-button [value]="condition.id" *ngFor="let condition of thinkReactionOptions">
							<span>{{ condition.name }}</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="question-wrapper">
					<div
						class="radio-btn-label"
						[translate]="'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.doesNotTakeLongToRecover'">
						It does not take me long time to recover from a stressful event.
					</div>
					<mat-radio-group
						[(ngModel)]="howYouThinkData.doesNotTakeLongToRecover"
						formControlName="doesNotTakeLongToRecover"
						[disabled]="readOnly">
						<mat-radio-button [value]="condition.id" *ngFor="let condition of thinkReactionOptions">
							<span>{{ condition.name }}</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="question-wrapper">
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.hardToSnapBackWhenBadHappens'
						">
						It is hard for me to snap back when something bad happens.
					</div>
					<mat-radio-group
						[(ngModel)]="howYouThinkData.hardToSnapBackWhenBadHappens"
						formControlName="hardToSnapBackWhenBadHappens"
						[disabled]="readOnly">
						<mat-radio-button [value]="condition.id" *ngFor="let condition of thinkReactionOptions">
							<span>{{ condition.name }}</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="question-wrapper">
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.comeThroughDifficultTimesEasily'
						">
						I usually come through difficult times with little trouble
					</div>
					<mat-radio-group
						[(ngModel)]="howYouThinkData.comeThroughDifficultTimesEasily"
						formControlName="comeThroughDifficultTimesEasily"
						[disabled]="readOnly">
						<mat-radio-button [value]="condition.id" *ngFor="let condition of thinkReactionOptions">
							<span>{{ condition.name }}</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="question-wrapper">
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.takeLongTimeToGetOverSetbacks'
						">
						I tend to take a long time to get over setbacks in my life.
					</div>
					<mat-radio-group
						[(ngModel)]="howYouThinkData.takeLongTimeToGetOverSetbacks"
						formControlName="takeLongTimeToGetOverSetbacks"
						[disabled]="readOnly">
						<mat-radio-button [value]="condition.id" *ngFor="let condition of thinkReactionOptions">
							<span>{{ condition.name }}</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="form-field">
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.victimDomesticViolencePast'
						">
						Within the past few years, have you been a victim of domestic violence (either physical or sexual) by a
						family member, significant other or caregiver?
					</div>
					<mat-radio-group formControlName="victimDomesticViolencePast" [disabled]="readOnly">
						<mat-radio-button [value]="true">
							<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.option-yes'"
								>Yes</span
							>
						</mat-radio-button>
						<mat-radio-button [value]="false">
							<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.option-no'"
								>No</span
							>
						</mat-radio-button>
					</mat-radio-group>
				</div>

				<div class="form-field">
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.committedDomesticViolencePast'
						">
						Within the past few years, have you committed domestic violence (either physical or sexual) against a family
						member, significant other or caregiver?
					</div>
					<mat-radio-group formControlName="committedDomesticViolencePast" [disabled]="readOnly">
						<mat-radio-button [value]="true">
							<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.option-yes'"
								>Yes</span
							>
						</mat-radio-button>
						<mat-radio-button [value]="false">
							<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-think.form-fields.option-no'"
								>No</span
							>
						</mat-radio-button>
					</mat-radio-group>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="next()">
	<button class="button button-medium" mat-button>
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
	</button>
</div>
